
enum Routes {
    "Acceuil"= "/",
    "Evenements de l'utilisateur"= 'events-purchased'
}

export default Routes;
